// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// PROBE ARTIFACT SCHEMA
/////////////////////////////////////////

/**
 * Reachable network service on a host (port + transport + application protocol).
 */
export const ProbeArtifactSchema = z.object({
  capturedAt: z.coerce.date(),
  rawBanner: z.string().nullable(),
  rawHeaders: z.string().nullable(),
  rawBody: z.string().nullable(),
  rawCert: z.string().nullable(),
  screenshot: z.string().nullable(),
})

export type ProbeArtifact = z.infer<typeof ProbeArtifactSchema>

export default ProbeArtifactSchema;
